class PromoCodeApi {
    constructor(options = {}) {
        this.applyUrl = options.applyUrl || null;
        this.validateUrl = options.validateUrl || null;
        this.csrfToken = options.csrfToken || null;
    }

    async request(url, payload = {}) {
        if (!url) {
            return Promise.resolve({
                success: false,
                message: 'Promo code endpoint is not configured.',
            });
        }

        const headers = {
            'Content-Type': 'application/json',
        };

        if (this.csrfToken) {
            headers['X-CSRF-TOKEN'] = this.csrfToken;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload),
        });

        try {
            return await response.json();
        } catch (error) {
            return {
                success: false,
                message: 'Unable to parse server response.',
            };
        }
    }

    applyDiscount(payload = {}) {
        return this.request(this.applyUrl, payload);
    }

    validatePromoCode(payload = {}) {
        return this.request(this.validateUrl, payload);
    }
}

export default PromoCodeApi;